import { render, staticRenderFns } from "./ExpConfigEdit.vue?vue&type=template&id=2137b066&scoped=true&"
import script from "./ExpConfigEdit.vue?vue&type=script&lang=js&"
export * from "./ExpConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137b066",
  null
  
)

export default component.exports